/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, isRejected } from "@reduxjs/toolkit";
import server from "api/server";

export const getTransactionLogsData = createAsyncThunk(
  "getTransactionLogs",

  async (payload: any) => {
    try {
      const { data } = await server.transactionLogs.getTransactionLogs(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getSpecificTransactionLog = createAsyncThunk(
  "getSPecificTransactionLog",

  async (payload: any) => {
    try {
      const { data } = await server.transactionLogs.getSpecificTransactionLog(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getStatesAction = createAsyncThunk(
  "getStatesAction",

  async (payload: any) => {
    try {
      const { data } = await server.pricingDashboard.getStates(payload);
      return data;
    } catch (error) {
      return isRejected(error);
    }
  },
);

export const resendDatasetEmail = createAsyncThunk(
  "resendDataSetEmail",

  async (payload: any) => {
    try {
      const { data } = await server.transactionLogs.resendDataset(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);
